export enum RegisterSteps {
    Register = 'register',
    WaitApprove = 'wait-approve',
}
